var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('van-nav-bar',{attrs:{"title":"球局管理","left-text":"返回","left-arrow":""},on:{"click-left":_vm.previousPage}})}
var staticRenderFns = []

export { render, staticRenderFns }